import { Game } from '../game.js';

export class SafeAreas
{
  public static renderTopSafeAreaOverlay( ctx: CanvasRenderingContext2D ): void
  {
    const safe_area_top = Game.safeAreaTop();

    if ( safe_area_top <= 0 )
      return;

    ctx.save();

    const overlay_x = 0 - Game.safeAreaLeft();
    const overlay_y = 0;
    const overlay_width = Game.screenW() + Game.safeAreaLeft() + Game.safeAreaRight();
    const overlay_height = safe_area_top + 4;

    const blur_height = 5;
    const main_height = overlay_height - blur_height;

    ctx.fillStyle = 'rgba(4, 56, 124, 0.34)';
    ctx.fillRect( overlay_x, overlay_y, overlay_width, main_height );

    const gradient = ctx.createLinearGradient( 0, overlay_y + main_height, 0, overlay_y + overlay_height );
    gradient.addColorStop( 0, 'rgba(4, 56, 124, 0.34)' );
    gradient.addColorStop( 1, 'rgba(4, 56, 124, 0)' );

    ctx.fillStyle = gradient;
    ctx.fillRect( overlay_x, overlay_y + main_height, overlay_width, blur_height );

    ctx.restore();
  }

  private static syncStripDom( host: HTMLElement, class_name: string, height: number, background: string, at_bottom: boolean ): void
  {
    let strip = host.querySelector<HTMLDivElement>( `:scope > .${class_name}` );

    if ( height <= 0 )
    {
      strip?.remove();
      return;
    }

    if ( !strip )
    {
      strip = document.createElement( "div" );
      strip.className = `ui-dom-safe ${class_name}`;
      const s = strip.style;
      s.position = "absolute";
      s.left = "0";
      s.right = "0";
      if ( at_bottom ) s.bottom = "0"; else s.top = "0";
      s.pointerEvents = "none";
      s.background = background;
    }

    const height_css = `${height}px`;
    if ( strip.style.height !== height_css )
      strip.style.height = height_css;

    const next = strip.nextElementSibling;
    if ( strip.parentNode !== host || ( next !== null && !next.classList.contains( "ui-dom-safe" ) ) )
      host.appendChild( strip );
  }

  public static syncTopSafeAreaOverlayDom( host: HTMLElement | null, visible: boolean = true ): void
  {
    if ( !host )
      return;
    const safe_area_top = visible ? Game.safeAreaTop() : 0;
    SafeAreas.syncStripDom(
      host,
      "ui-dom-safe-top",
      safe_area_top > 0 ? safe_area_top + 4 : 0,
      "linear-gradient(rgba(4, 56, 124, 0.34) calc(100% - 5px), rgba(4, 56, 124, 0))",
      false
    );
  }

  public static syncBottomSafeAreaOverlayDom( host: HTMLElement | null, visible: boolean = true ): void
  {
    if ( !host )
      return;
    const safe_area_bottom = visible ? Game.safeAreaBottom() : 0;
    SafeAreas.syncStripDom(
      host,
      "ui-dom-safe-bottom",
      safe_area_bottom,
      "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.24) 5px)",
      true
    );
  }

  public static syncBothSafeAreaOverlaysDom( host: HTMLElement | null, visible: boolean = true ): void
  {
    SafeAreas.syncTopSafeAreaOverlayDom( host, visible );
    SafeAreas.syncBottomSafeAreaOverlayDom( host, visible );
  }

  public static renderBottomSafeAreaOverlay( ctx: CanvasRenderingContext2D ): void
  {
    const safe_area_bottom = Game.safeAreaBottom();

    if ( safe_area_bottom <= 0 )
      return;


    ctx.save();
    const overlay_x = 0;
    const overlay_y = Game.screenH() - Game.safeAreaBottom();
    const overlay_width = Game.screenW();
    const overlay_height = safe_area_bottom;

    const blur_height = 5;
    const main_height = overlay_height - blur_height;

    ctx.fillStyle = 'rgba(0,0,0,0.24)';
    ctx.fillRect( overlay_x, overlay_y + blur_height, overlay_width, main_height );

    const gradient = ctx.createLinearGradient( 0, overlay_y + blur_height, 0, overlay_y );
    gradient.addColorStop( 0, 'rgba(0,0,0,0.24)' );
    gradient.addColorStop( 1, 'rgba(0, 0, 0, 0)' );

    ctx.fillStyle = gradient;
    ctx.fillRect( overlay_x, overlay_y, overlay_width, blur_height );

    ctx.restore();
  }

  public static renderBothSafeAreaOverlays( ctx: CanvasRenderingContext2D ): void
  {
    SafeAreas.renderTopSafeAreaOverlay( ctx );
    SafeAreas.renderBottomSafeAreaOverlay( ctx );
  }
}
